import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostBinding } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment';
import { Observable } from 'rxjs';
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate.js';
import { ScrollContainerComponent } from '../common/components/scroll.container/scroll.container.component';
import { FilterDateRangButtonComponent } from '../common/filter/filter.date.range.button.component';
import { FilterMultiComponent } from '../common/filter/filter.multi.component';
import {
  FilterDateRange,
  FilterMulti,
  FilterObject,
} from '../common/filter/list.filter';
import {
  ListOption,
  ScrollableListComponentBase,
} from '../common/list.component.base';
import { DELETED, WebUtils } from '../common/utils';
import { XlsUtils } from '../common/xls.utils';
import { AccessUtils, TBooking, TLocation, TSpace } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SessionCache } from '../session.cache';
import { SessionService } from '../session.service';
import { BookingMixin } from '../thinkdesks/booking.mixin';
import { SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { ThinkdesksCache } from '../thinkdesks/thinkdesks.cache';
import {
  TBookingStatus,
  TBookingType,
} from '../thinkdesks/thinkdesks.entities';
import { BookingDialogComponent } from './booking.dialog.component';
import { BookingExportDialogComponent } from './booking.export.dialog.component';

class _Base extends ScrollableListComponentBase<TBooking> { }

@Component({
  selector: 'app-booking-space-list',
  templateUrl: './booking.space.list.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FilterMultiComponent,
    ScrollContainerComponent,
    FontAwesomeModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
    FilterMultiComponent,
    FilterDateRangButtonComponent,
    BookingExportDialogComponent,
  ],
})
export class BookingSpaceListComponent extends SiteLangMixin(
  BookingMixin(SiteFormatMixin(_Base))
) {
  _common = _common;
  @HostBinding('class') css = 'max-height';

  now = moment();

  filterObject = new FilterObject();
  dateRange = new FilterDateRange();
  space = new FilterMulti();
  location = new FilterMulti();
  status = new FilterMulti();
  statusList = TBookingStatus;
  //   type = new FilterMulti();

  spaces: TSpace[] = [];
  _spaces: TSpace[] = [];
  displayedColumns: string[] = [
    //'id',
    //'bookingNo',
    'status',
    'name',
    'space',
    'locked',
    'time',
    'purpose',
    'checkin',
    // 'participants',
    // 'walkins',

    'date',

    'controls',
  ];

  locations: TLocation[] = [];
  constructor(
    override http: HttpClient,
    override elRef: ElementRef,
    private dialog: MatDialog,
    override snackBar: MatSnackBar,
    private cache: SessionCache,
    public override session: SessionService,
    private thinkDesksCache: ThinkdesksCache
  ) {
    super(http, snackBar, elRef);
    this.pageSort = 'date';
    this.pageSortDir = 'desc';

    this.filterObject.add('space', this.space);
    this.filterObject.add('locations', this.location);
    this.filterObject.add('status', this.status);
    this.filterObject.add('dateRange', this.dateRange);

    this.thinkDesksCache.loadSpaceByLocations(
      this.session.locations.map((c) => c.id),
      (list) => {
        this.spaces = list;
        this._spaces = list;
      }
    );
    this.cache.loadManagedLocation(this.session, (list) => {
      this.locations = list;

    });
    // this.thinkDesksCache.loadSpace(0, (list) => {
    //   this.spaces = list;
    // });
  }

  updateLocation() {
    this.space.clear();
    let qq = this.location.query().map((c) => parseInt(c));
    this.spaces = this._spaces.filter((c) => {
      return qq.includes(c.location.id)
    })
    this.refresh();
  }

  createQueryBase() {
    let query = {} as any;
    let filter = this.filterObject.query()
    Object.assign(query, filter);
    this.session.mergeQuery(query);
    // Object.assign(query, this.session.userQuery());


    query.type = TBookingType.space;

    return query;
  }
  override createRequest(options: ListOption): Observable<Object> {
    let query = this.createQueryBase();
    const url = this._listModifyUrl(`/api/booking/list`, {}, options);
    return this.http.post(url, query);
  }

  override listFixList(list: TBooking[]) {
    for (let o of list) {
      AccessUtils.fixBooking(o);
      if (o.space) AccessUtils.fixSpace(o.space as TSpace);
    }
  }

  add() { }

  override selectObject(o: TBooking) {
    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: {
        objectId: o.id,
        object: o,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == DELETED) {
        this._removeFromList(o);
      } else if (result) {
        Object.assign(o, result);
      }
    });
  }

  exportList() {
    const dialogRef = this.dialog.open(BookingExportDialogComponent, {
      width: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let checkinTime = result.checkinTime;
        let query = this.createQueryBase();
        Object.assign(query, result);
        // query.dateRange = result;

        WebUtils.web_list(
          this.http.post(`/api/client/booking/list2`, query),
          (result) => {
            let list = result as any[];
            for (let o of list) {
              AccessUtils.fixBooking(o);
              if (o.space) AccessUtils.fixSpace(o.space as TSpace);

              o.participants = o.participants ?? []
              o.participants = o.participants.filter(c => c.member)
              if (checkinTime) {
                let logs = o.checkinLogs ?? [];
                let participants = o.participants ?? [];
                for (let p of participants) {
                  let llist = logs.filter(c => c.member?.id == p.member.id)
                  llist.sort((a, b) => a.time.diff(b.time))
                  p.log = llist[0];
                }
              }
            }
            this.doExport(list);
          }
        );
      }
    });
  }

  doExport(dataList: any[]) {
    XlsxPopulate.fromBlankAsync().then((workbook: XlsxPopulate.Workbook) => {
      const sheet = workbook.sheet('Sheet1');
      const now = new Date();
      const pad = (n: number) => n.toString().padStart(2, '0');
      const dateStr = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`;
      this.exportSheet(sheet, dataList);
      XlsUtils.webExport(workbook, null, {
        filename: `Booking_records_${dateStr}.xlsx`,
      });
    });
  }

  exportSheet(sheet: XlsxPopulate.Sheet, dataList: any) {
    let columnOrder = [
      {
        path: 'bookingNo',
        name: 'Booking ID',
      },
      {
        path: 'date',
        name: 'Created Date',
      },
      {
        path: 'space.location.name',
        name: 'Center Name (zh_hk)',
      },
      {
        path: 'space.location.name_lang.en',
        name: 'Center Name (en)',
      },
      {
        path: 'space.location.organization.name',
        name: 'Organization (zh_hk)',
      },
      {
        path: 'space.location.organization.name_lang.en',
        name: 'Organization (en)',
      },
      {
        path: 'space.id',
        name: 'Space System ID',
      },
      {
        path: 'space.name',
        name: 'Space',
      },
      {
        path: 'purpose.name',
        name: 'Theme',
      },
      {
        path: 'space.autoApprove',
        name: 'Auto Approve (Y/N)',
      },
      {
        path: 'facilities',
        name: 'Facilities',
      },
      {
        path: 'remarks',
        name: 'Remarks',
      },
      {
        path: 'startTime',
        name: 'Start Time',
      },
      {
        path: 'endTime',
        name: 'End Time',
      },
      {
        path: 'status',
        name: 'Status',
      },
      {
        path: 'member.userId',
        name: 'Member UUID',
      },
      {
        path: 'member.name',
        name: 'Member Name',
      },
      {
        path: 'member.mobile',
        name: 'Member Tel',
      },
      {
        path: 'member.email',
        name: 'Member Email',
      },

      {
        path: 'member.memberType.name',
        name: 'Member Type',
      },
      {
        path: 'contactName',
        name: 'Contact Name',
      },
      {
        path: 'contactMobile',
        name: 'Tel',
      },
      {
        path: 'contactEmail',
        name: 'Email',
      },
      {
        path: 'checkin.time',
        name: 'Checkin Time',
      },
      {
        path: 'cancelReason',
        name: 'Cancel Reason',
      },
      {
        path: 'cancelDate',
        name: 'Cancel Time',
      },
      {
        path: 'cancelMember.name',
        name: 'Cancelled by',
      },
      {
        path: 'cancelMember.userId',
        name: 'Cancelled by (UUID)',
      },
      {
        path: 'cancelMember.memberType.name',
        name: 'Cancelled by (Member Type)',
      },
      {
        path: 'rejectDate',
        name: 'Reject Time',
      },
      {
        path: 'rejectMember.name',
        name: 'Rejected by',
      },
      {
        path: 'rejectMember.userId',
        name: 'Rejected by (UUID)',
      },
      {
        path: 'approveDate',
        name: 'Approve Time',
      },
      {
        path: 'approveMember.name',
        name: 'Approved by',
      },
      {
        path: 'approveMember.userId',
        name: 'Approved by (UUID)',
      },
      {
        path: 'space.locked',
        name: 'Smart Lock',
      },
      {
        path: 'numParticipants',
        name: 'Expected No. of Participants',
      },
      {
        path: 'participantNames',
        name: 'Participants Name',
      },
      {
        path: 'participantIds',
        name: 'Participants UUID',
      },
      {
        path: 'participantCount',
        name: 'Total no. of Participants',
      },
      {
        path: 'walkinNames',
        name: 'Participants(Walk-in) Name',
      },
      {
        path: 'walkinIds',
        name: 'Participants(Walk-in) UUID',
      },
      {
        path: 'walkinCount',
        name: 'Total no. of Participants(Walk-in)',
      },
    ];

    const header = columnOrder.map((column) => column.name);
    const cells = [header];

    for (const booking of dataList) {
      const data = columnOrder.map((column) => {
        const columnKeys = column.path.split('.');
        let cell = booking;

        switch (column.path) {
          case 'space.autoApprove':
            return cell.space.autoApprove ? 'Y' : 'N';
          case 'space.locked':
            return cell.space.locked ? 'Y' : 'N';
          case 'cancelMember.name':
            if (!cell.cancelDate) return '';
            return (cell.cancelMember ?? cell.member).name
          case 'cancelMember.userId':
            if (!cell.cancelDate) return '';
            return (cell.cancelMember ?? cell.member).userId
          case 'cancelMember.memberType.name':
            if (!cell.cancelDate) return '';
            return (cell.cancelMember ?? cell.member).memberType?.name
          case 'cancelReason':
            return `${cell.cancelReasonCode ?? ''} ${cell.cancelReason ?? ''}`;
          case 'facilities':
            return cell.facilities
              .map((t) => this.lang(t.name, t.name_lang))
              .join(', ');
          case 'startTime':
          case 'endTime':
          case 'rejectDate':
          case 'date':
          case 'cancelDate':
          case 'approveDate':
            return this.formatTime(cell[column.path]);

          case 'checkin.time':
            return this.formatTime(cell?.checkin?.time);
          case 'status':
            return this._common.bookingStatus[cell.status];
          case 'participantNames':
            {
              let list = cell.participants ?? [];
              return list.filter((c) => !c.walkin && c.member).map((t) => {
                let s = t.member.name;
                if (t.log) {
                  s += ` (${t.log.time.format('YYYY-MM-DD HH:mm')})`
                }
                return s;
              }).join(', ');
            }
          case 'participantIds':
            {
              let list = cell.participants ?? [];
              return list.filter((c) => !c.walkin && c.member).map((t) => t.member.userId).join(', ');
            }
          case 'participantCount':
            {
              let list = cell.participants ?? [];
              return list.filter((c) => !c.walkin).length;
            }
          case 'walkinNames':
            {
              let list = cell.participants ?? [];

              return list.filter((c) => c.walkin && c.member).map((t) => {
                let s = t.member.name;
                if (t.log) {
                  s += ` (${t.log.time.format('YYYY-MM-DD HH:mm')})`
                }
                return s;
              }).join(', ');
            }
          case 'walkinIds':
            {
              let list = cell.participants ?? [];
              return list.filter((c) => c.walkin).map((t) => t.member.userId).join(', ');
            }
          case 'walkinCount':
            {
              let list = cell.participants ?? [];
              return list.filter((c) => c.walkin).length;
            }
        }

        for (const columnKey of columnKeys) {
          if (!cell[columnKey]) return '';
          else cell = cell[columnKey];
        }
        return cell;
      });

      cells.push(data);
    }

    sheet.cell('A1').value(cells);
  }


}
